import styled from 'styled-components';
import { theme, toRem } from 'design';

export const BusinessDateInputWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(5.5)};

  p {
    text-align: right;
    color: ${theme.color.danger.medium} !important;
  }
`;

export const PayeesContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
`;

export const PaymentCategoryWrapper = styled.div`
  width: ${toRem(160)};
  margin-left: ${toRem(6)};
`;
